module.exports = __webpack_public_path__ + "media/images/photo_shoot_hero-eec15032f5b27aacd841fadb2f458f2a.jpg";